import { VHCRecordCheckItemInput, VhcRecordLogService } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type UpdateDefaultItemInput = {
  logId: number;
  itemId: number;
  requestBody?: VHCRecordCheckItemInput;
};

export const useUpdateDefaultItemMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.putVhcRecordsItemsChecks, UpdateDefaultItemInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, requestBody }: UpdateDefaultItemInput) =>
      VhcRecordLogService.putVhcRecordsItemsChecks(logId, itemId, requestBody),
    options
  );
